const variables = {
  cta: {
    icon: 'ChevronRight',
    variant: 'primary',
  },
  settings: {
    cardTheme: null,
  },
};

export default variables;
